import Env from '../../base/env'
import Channels from '../../base/channels'
import raf from 'raf'
import Waypoint from '../../vendor/waypoints'

export default class Logo
{
    constructor(view)
    {
        // DOM
        this.view = view
        this.$sticky = this.view.querySelector('.jsLogo--sticky')
        this.$follow = this.view.querySelector('.jsLogo--follow')
        this.$reveal = this.view.querySelector('.jsWaypoint--revealLogo')
        // Objects
        this.raf = false
        this.offsetRevealY = 0
        this.waypointToggle = false
        // Flags
        this.SCALE_LEVEL = .3
        this.TOP_FOLLOW_VAL = 30
        // Fns
        this.funcResize = this.resize.bind(this)
    }

    draw()
    {
        const viewport = Env.framework.toolbox.getViewport()
        const coordinatesLogo = this.$sticky.getBoundingClientRect()
        this.offsetRevealY = (viewport.height / 2) - (coordinatesLogo.height / 2) - this.TOP_FOLLOW_VAL

        this.waypointToggle = new Waypoint({
            element: this.$reveal,
            handler: (direction)=> {
                if(direction === 'down') {
                    this.view.classList.add('logo--attached')
                } else {
                    this.view.classList.remove('logo--attached')
                }
            },
            offset: this.offsetRevealY
        });
    }

    destroy()
    {
        Channels.removeListener('window::smartresize',this.funcResize)
        raf.cancel(this.raf)
    }

    events()
    {
        Channels.on('window::smartresize',this.funcResize)
    }

    resize()
    {
        this.waypointToggle.destroy()
        this.draw()
    }

    setup()
    {
        this.draw()
        this.events()
    }

    start()
    {
        this.watcher()
    }

    watcher()
    {
        this.raf = raf(()=>{
            this.watcher()
        })

        const coordReveal = this.$reveal.getBoundingClientRect()
        let ratio = coordReveal.top / this.offsetRevealY
        if(ratio > 1) {
            ratio = 1
        } else if(ratio < 0) {
            ratio = 0
        }
        const ratioScale = this.SCALE_LEVEL - (ratio * this.SCALE_LEVEL)
        const valueScale = 1 - ratioScale
        TweenLite.set(this.$follow , { scale : valueScale })
    }
}


// WEBPACK FOOTER //
// ./resources/js/components/home/Logo.js